const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Gestor de Correo Corporativo — Inbox de Correo",
    summary:
      "Módulo integral de correo electrónico empresarial con soporte de sincronización bidireccional IMAP/SMTP y OAuth (Google Workspace / Outlook). Centraliza las comunicaciones formales de tus clientes vinculadas a sus tickets de soporte y contactos del CRM.",
  },
  sections: [
    {
      id: "bandejas_correo",
      title: "1. Bandejas y Organización de Correo",
      description:
        "Estructura de navegación de cuentas de correo vinculadas.",
      items: [
        {
          id: "inbox_recibidos",
          title: "Bandeja de Entrada (Recibidos)",
          definition:
            "Listado de correos entrantes sincronizados en tiempo real desde los servidores IMAP de cada cuenta configurada.",
          importance:
            "Permite previsualizar el remitente, asunto, fecha de recepción y fragmento del cuerpo del mensaje.",
        },
        {
          id: "inbox_enviados",
          title: "Correos Enviados",
          definition:
            "Historial de mensajes redactados y despachados exitosamente desde la plataforma BotMix vía SMTP.",
        },
        {
          id: "inbox_papelera",
          title: "Papelera y Spam",
          definition:
            "Correos eliminados o clasificados como no deseados con opción de restauración o vaciado permanente.",
        },
      ],
    },
    {
      id: "redactor_correo",
      title: "2. Redacción y Envío Enriquecido",
      description:
        "Editor de texto con capacidades avanzadas de formato corporativo.",
      items: [
        {
          id: "editor_html",
          title: "Editor WYSIWYG Enriquecido",
          definition:
            "Formateo completo de texto con negritas, listas, enlaces, tablas y firmas personalizadas de empresa.",
        },
        {
          id: "archivos_adjuntos",
          title: "Archivos Adjuntos (PDF, Imágenes, Documentos)",
          definition:
            "Subida y envío seguro de archivos anexos con control de tamaño y validación de extensiones permitidas.",
        },
        {
          id: "asociacion_crm",
          title: "Vinculación Automática al Contacto CRM",
          definition:
            "Si el remitente coincide con un contacto existente en BotMix, el correo queda registrado en su expediente omnicanal.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "Official BotMix Guide",
    title: "Corporate Email Manager — Email Inbox",
    summary:
      "Comprehensive corporate email module supporting bi-directional IMAP/SMTP synchronization and OAuth (Google Workspace / Outlook). Centralizes formal customer communications linked to their support tickets and CRM contacts.",
  },
  sections: [
    {
      id: "bandejas_correo",
      title: "1. Inboxes and Email Organization",
      description:
        "Navigation structure for linked email accounts.",
      items: [
        {
          id: "inbox_recibidos",
          title: "Inbox (Received)",
          definition:
            "List of incoming emails synchronized in real-time from the IMAP servers of each configured account.",
          importance:
            "Allows previewing the sender, subject, reception date, and snippet of the message body.",
        },
        {
          id: "inbox_enviados",
          title: "Sent Emails",
          definition:
            "History of messages drafted and successfully dispatched from the BotMix platform via SMTP.",
        },
        {
          id: "inbox_papelera",
          title: "Trash and Spam",
          definition:
            "Deleted or junk-classified emails with restore or permanent purge options.",
        },
      ],
    },
    {
      id: "redactor_correo",
      title: "2. Drafting and Rich Sending",
      description:
        "Text editor with advanced corporate formatting capabilities.",
      items: [
        {
          id: "editor_html",
          title: "Rich WYSIWYG Editor",
          definition:
            "Full text formatting with bold, lists, links, tables, and custom company signatures.",
        },
        {
          id: "archivos_adjuntos",
          title: "File Attachments (PDF, Images, Documents)",
          definition:
            "Secure upload and delivery of attached files with size control and extension validation.",
        },
        {
          id: "asociacion_crm",
          title: "Automatic CRM Contact Linking",
          definition:
            "If the sender matches an existing contact in BotMix, the email is logged into their omnichannel record.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Gerenciador de E-mail Corporativo — Caixa de Entrada de E-mail",
    summary:
      "Módulo abrangente de e-mail corporativo com suporte à sincronização bidirecional IMAP/SMTP e OAuth (Google Workspace / Outlook). Centraliza as comunicações formais dos seus clientes vinculadas aos tickets de suporte e contatos do CRM.",
  },
  sections: [
    {
      id: "bandejas_correo",
      title: "1. Pastas e Organização de E-mail",
      description:
        "Estrutura de navegação das contas de e-mail vinculadas.",
      items: [
        {
          id: "inbox_recibidos",
          title: "Caixa de Entrada (Recebidos)",
          definition:
            "Lista de e-mails recebidos sincronizados em tempo real a partir dos servidores IMAP de cada conta configurada.",
          importance:
            "Permite pré-visualizar o remetente, assunto, data de recebimento e trecho do corpo da mensagem.",
        },
        {
          id: "inbox_enviados",
          title: "E-mails Enviados",
          definition:
            "Histórico de mensagens redigidas e enviadas com sucesso a partir da plataforma BotMix via SMTP.",
        },
        {
          id: "inbox_papelera",
          title: "Lixeira e Spam",
          definition:
            "E-mails excluídos ou classificados como indesejados com opção de restauração ou esvaziamento permanente.",
        },
      ],
    },
    {
      id: "redactor_correo",
      title: "2. Redação e Envio Enriquecido",
      description:
        "Editor de texto com recursos avançados de formatação corporativa.",
      items: [
        {
          id: "editor_html",
          title: "Editor WYSIWYG Enriquecido",
          definition:
            "Formatação completa de texto com negrito, listas, links, tabelas e assinaturas personalizadas da empresa.",
        },
        {
          id: "archivos_adjuntos",
          title: "Arquivos Anexados (PDF, Imagens, Documentos)",
          definition:
            "Upload e envio seguro de arquivos anexos com controle de tamanho e validação de extensões permitidas.",
        },
        {
          id: "asociacion_crm",
          title: "Vinculação Automática ao Contato do CRM",
          definition:
            "Se o remetente coincidir com um contato existente no BotMix, o e-mail fica registrado em seu histórico omnicanal.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Gestionnaire de Courrier d'Entreprise — Boîte de Réception",
    summary:
      "Module complet de messagerie professionnelle prenant en charge la synchronisation bidirectionnelle IMAP/SMTP et OAuth (Google Workspace / Outlook). Centralise les communications formelles de vos clients liées à leurs tickets d'assistance et contacts CRM.",
  },
  sections: [
    {
      id: "bandejas_correo",
      title: "1. Dossiers et Organisation des E-mails",
      description:
        "Structure de navigation des comptes de messagerie associés.",
      items: [
        {
          id: "inbox_recibidos",
          title: "Boîte de Réception (Reçus)",
          definition:
            "Liste des courriels entrants synchronisés en temps réel depuis les serveurs IMAP de chaque compte configuré.",
          importance:
            "Permet de prévisualiser l'expéditeur, l'objet, la date de réception et un extrait du corps du message.",
        },
        {
          id: "inbox_enviados",
          title: "Courriels Envoyés",
          definition:
            "Historique des messages rédigés et expédiés avec succès depuis la plateforme BotMix via SMTP.",
        },
        {
          id: "inbox_papelera",
          title: "Corbeille et Spam",
          definition:
            "Courriels supprimés ou classés comme indésirables avec option de restauration ou de suppression définitive.",
        },
      ],
    },
    {
      id: "redactor_correo",
      title: "2. Rédaction et Envoi Enrichi",
      description:
        "Éditeur de texte doté de fonctionnalités avancées de mise en forme professionnelle.",
      items: [
        {
          id: "editor_html",
          title: "Éditeur WYSIWYG Enrichi",
          definition:
            "Mise en forme complète du texte avec gras, listes, liens, tableaux et signatures d'entreprise personnalisées.",
        },
        {
          id: "archivos_adjuntos",
          title: "Pièces Jointes (PDF, Images, Documents)",
          definition:
            "Téléversement et envoi sécurisé de pièces jointes avec contrôle de taille et validation des extensions autorisées.",
        },
        {
          id: "asociacion_crm",
          title: "Liaison Automatique au Contact CRM",
          definition:
            "Si l'expéditeur correspond à un contact existant dans BotMix, le courriel est consigné dans son dossier omnicanal.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "الدليل الرسمي لـ BotMix",
    title: "مدير البريد الإلكتروني للمؤسسات — صندوق البريد",
    summary:
      "وحدة متكاملة لإدارة البريد الإلكتروني للشركات مع دعم المزامنة ثنائية الاتجاه عبر IMAP/SMTP وOAuth (Google Workspace / Outlook). توحد الاتصالات الرسمية لعملائك المرتبطة بتذاكر الدعم وسجلات جهات اتصال CRM.",
  },
  sections: [
    {
      id: "bandejas_correo",
      title: "1. مجلدات البريد والتنظيم",
      description:
        "هيكل التنقل لحسابات البريد الإلكتروني المرتبطة.",
      items: [
        {
          id: "inbox_recibidos",
          title: "صندوق الوارد (المستلم)",
          definition:
            "قائمة رسائل البريد الإلكتروني الواردة المتزامنة في الوقت الفعلي من خوادم IMAP لكل حساب مهيأ.",
          importance:
            "يتيح معاينة المرسل والموضوع وتاريخ الاستلام ومقتطف من نص الرسالة.",
        },
        {
          id: "inbox_enviados",
          title: "البريد المرسل",
          definition:
            "سجل الرسائل التي تمت صياغتها وإرسالها بنجاح من منصة BotMix عبر SMTP.",
        },
        {
          id: "inbox_papelera",
          title: "سلة المهملات والبريد العشوائي",
          definition:
            "الرسائل المحذوفة أو المصنفة كبريد غير مرغوب فيه مع خيار الاستعادة أو الإفراغ النهائي.",
        },
      ],
    },
    {
      id: "redactor_correo",
      title: "2. الصياغة والإرسال المتقدم",
      description:
        "محرر نصوص بإمكانيات تنسيق مؤسسية متقدمة.",
      items: [
        {
          id: "editor_html",
          title: "محرر WYSIWYG متقدم",
          definition:
            "تنسيق كامل للنص مع خط عريض وقوائم وروابط وجداول وتوقيعات مخصصة للشركة.",
        },
        {
          id: "archivos_adjuntos",
          title: "الملفات المرفقة (PDF، صور، مستندات)",
          definition:
            "رفع وإرسال آمن للملفات المرفقة مع التحكم في الحجم والتحقق من الامتدادات المسموح بها.",
        },
        {
          id: "asociacion_crm",
          title: "الربط التلقائي بجهة اتصال CRM",
          definition:
            "إذا تطابق المرسل مع جهة اتصال موجودة في BotMix، يتم تسجيل البريد في سجلها الشامل متعدد القنوات.",
        },
      ],
    },
  ],
};

export const EMAILS_HELP_DATA = {
  es,
  en,
  pt,
  fr,
  ar,
};
